import { LazyMarkdown } from 'components/LazyMarkdown'
import remarkGfm from 'remark-gfm'

// Author-configured Course Materials instructions, rendered identically in the
// admin preview and the participant modals.
export function CourseMaterialsInstructionsMarkdown({
  children,
}: {
  children: string
}) {
  return (
    <div className="course-materials-instructions-markdown text-body-large text-on-surface-var">
      <LazyMarkdown remarkPlugins={[remarkGfm]}>{children}</LazyMarkdown>
    </div>
  )
}
